import { dateColDefs } from '@/constants/ag-grid-scenario-builder.constant'
import { optimizationDefaultColDefs } from '@/constants/portfolioOptimization.constant'
import { ColDef } from '@ag-grid-community/core'

export const CandidateScreenSecuritiesColumns = [
  {
    ...optimizationDefaultColDefs,
    headerName: 'Sec ID',
    field: 'sec_id',
    tooltipField: 'sec_id',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Description',
    field: 'description',
    tooltipField: 'description',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    field: 'coupon',
    tooltipField: 'coupon',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...{ ...optimizationDefaultColDefs, ...dateColDefs },
    field: 'maturity',
    tooltipField: 'maturity',
    cellDataType: 'date',
    filter: 'agDateColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    field: 'sector',
    tooltipField: 'sector',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Rating',
    field: 'moody',
    tooltipField: 'moody',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'S&P Quality',
    field: 'sandp',
    tooltipField: 'sandp',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    field: 'outstanding',
    tooltipField: 'outstanding',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Country',
    field: 'country',
    tooltipField: 'country',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Currency',
    field: 'currency',
    tooltipField: 'currency',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    field: 'price',
    tooltipField: 'price',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Yield to Maturity',
    field: 'ytm',
    tooltipField: 'ytm',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Effective Duration - Level',
    field: 'edur',
    tooltipField: 'edur',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
] as ColDef[]
